module.exports = __webpack_public_path__ + "img/title.5182614d.png";